import { useState, useMemo } from 'react'

export const useBooking = ({
  package: pkg,
  addOns = [],
  initialAddOnIds = [],
  initialDate = '',
  initialTime = '',
  initialPartySize = 1,
  venueHireFeePence = 0
}) => {
  const [selectedAddOnIds, setSelectedAddOnIds] = useState(new Set(initialAddOnIds))
  const [date, setDate] = useState(initialDate || '')
  const [time, setTime] = useState(initialTime || '')
  const [partySize, setPartySize] = useState(initialPartySize)

  const toggleAddOn = (addOnId) => {
    setSelectedAddOnIds(prev => {
      const next = new Set(prev)
      if (next.has(addOnId)) {
        next.delete(addOnId)
      } else {
        next.add(addOnId)
      }
      return next
    })
  }

  const selectedAddOns = useMemo(() => {
    return addOns.filter(a => selectedAddOnIds.has(a.id))
  }, [addOns, selectedAddOnIds])

  const perPersonTotal = useMemo(() => {
    const perPersonAddOns = selectedAddOns
      .filter(a => a.price_type !== 'flat')
      .reduce((sum, a) => sum + a.price_pence, 0)
    return (pkg?.base_price_pence || 0) + perPersonAddOns
  }, [pkg, selectedAddOns])

  const flatTotal = useMemo(() => {
    return selectedAddOns
      .filter(a => a.price_type === 'flat')
      .reduce((sum, a) => sum + a.price_pence, 0)
  }, [selectedAddOns])

  const total = useMemo(() => {
    return perPersonTotal * partySize + flatTotal + (venueHireFeePence || 0)
  }, [perPersonTotal, partySize, flatTotal, venueHireFeePence])

  return {
    selectedAddOnIds: Array.from(selectedAddOnIds),
    selectedAddOns,
    toggleAddOn,
    date,
    setDate,
    time,
    setTime,
    partySize,
    setPartySize,
    perPersonTotal,
    flatTotal,
    venueHireFeePence: venueHireFeePence || 0,
    total
  }
}
